import variables from "../../assets/styles/variables.scss";

export const locals = { locals: variables };
